
export default async function ($store) {

  if (null !== $store.state.currentUser.id && 0 === ($store.state.companies || []).length) {
    // Do migrate!
    await $store.dispatch('migrationTo110Action');
  }
}
